import axios from 'axios'
import { TransactionHeaderName } from '@/store/modules/Transaction'

const handleNonJsonError = function (error) {
  if (error.response && error.response.headers) {
    if (error.response.headers['content-type'] !== 'application/json') {
      error.response.data = 'Es trat ein Netzwerk-Fehler auf: ' + error.response.status
    }
  }
  throw error
}

export const TransactionName = 'Auth'

const AuthenticationModule = {
  state: {
    authenticationToken: null
  },
  mutations: {
    authenticate (state, authenticationToken) {
      const expiresAt = new Date()
      expiresAt.setSeconds(expiresAt.getSeconds() + authenticationToken.expires_in)
      state.authenticationToken = {
        accessToken: authenticationToken.access_token,
        refreshToken: authenticationToken.refresh_token,
        expiresAtTS: expiresAt.getTime()
      }
    },
    logout (state) {
      state.authenticationToken = null
    }
  },
  actions: {
    async login ({ commit, state, getters, dispatch, rootGetters }, { username, password }) {
      try {
        commit('clearMessages', {}, { root: true })
        commit('Transaction/createTransactionId', TransactionName)
        const headers = {}
        headers[TransactionHeaderName] = getters['Transaction/transactionIds'][TransactionName]
        const response = await axios.post(getters.baseUrl + '/api/token', {
          grant_type: 'password',
          client_id: getters.clientId,
          client_secret: getters.clientSecret,
          username: username,
          password: password
        }, {
          headers
        })
        commit('authenticate', response.data)
        commit('Transaction/updateAccessTokenHash', TransactionName)

        // const isCurrentProcessActivation = rootGetters['activation/activationProcess']
        // if (isCurrentProcessActivation === false) {
        await dispatch('V2/tariffOptions/fetchTariffOptions', null, { root: true })
        // }
        return state.authenticationToken.accessToken
      } catch (error) {
        throw handleNonJsonError(error)
      }
    },
    async logout ({ commit, state, getters }) {
      if (state.authenticationToken?.accessToken) {
        const headers = {}
        headers[TransactionHeaderName] = getters['Transaction/transactionIds'][TransactionName]

        await axios.delete(getters.baseUrl + '/api/token', {
          data: {
            access_token: state.authenticationToken.accessToken
          },
          headers
        })
      }

      commit('logout')
      commit('Transaction/resetTransactionId', TransactionName)
    },
    updateAuthTokens ({ commit, state }, authenticationToken) {
      if (state.authenticationToken?.accessToken !== authenticationToken.access_token) {
        commit('authenticate', authenticationToken)
      }
    },
    removeAuthTokens ({ commit }) {
      commit('authenticate', {
        access_token: null,
        refresh_token: null,
        expires_in: 0
      })
    }
  },
  getters: {
    isAuthenticated: state => {
      return state.authenticationToken?.accessToken != null
    },
    accessToken: state => {
      return state.authenticationToken?.accessToken
    },
    refreshToken: state => {
      return state.authenticationToken?.refreshToken
    }
  }
}

export {
  AuthenticationModule
}
